export default __webpack_public_path__ + "static/media/button.c8e36db6.png";